import { observer } from 'mobx-react-lite'
import React from 'react'
import classnames from 'classnames'
import { CallHistoryDropdownFilter } from 'pages/conversations/pages/calls/ui/CallHistoryDropdownFilter'
import { CallHistoryFilters } from 'pages/conversations/pages/calls/ui/CallHistoryFilters'
import { useCallHistoryContext } from 'pages/conversations/pages/calls/ui/CallHistory/context/callHistoryContext'
import styles from './styles.module.scss'

export const CallHistoryMobileHeader = observer(() => {
  const store = useCallHistoryContext()
  return (
    <div className={classnames(styles.wrap)}>
      <CallHistoryFilters store={store} variant={'dropdown'} />
      <CallHistoryDropdownFilter store={store.filtersStore} />
    </div>
  )
})
